module.exports = "<div class=\"container\">\n\n  <p *ngFor=\"let channel of ResolveChannels\">\n    <a uiSref=\"show.masterdetail\" [uiParams]=\"{chcode: channel.Code}\">\n      {{channel.Name}} {{channel.Code}}\n    </a>\n  </p>\n\n</div>\n\n<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-master/show-master.component.html
// module id = ../../../../../src/app/show-master/show-master.component.html
// module chunks = main